import useFeatureSettingsUpdate from './useFeatureSettingsUpdate';

export default function useGpsOutsideProjectReportSettingsUpdate() {
  return useFeatureSettingsUpdate('gpsOutsideProjectReport');
}
